export var TRAY_OPEN_CLOSE_DURATION = 750;